<div class="content-card sidebar-card doc-center-card">
    <div class="doc-center-header">
        <div class="header-title">Document Center</div>
        @if (!caseCompleted) {
        <button class="doc-center-add-btn" (click)="openUploadModal()">
            <hugeicons-icon [icon]="uploadIcon" [size]="14" color="currentColor"></hugeicons-icon>
            Upload
        </button>
        }
    </div>
    @if (loading) {
        <div class="doc-center-loading">
            <div class="doc-center-loading-spinner"></div>
            <span>Loading documents...</span>
        </div>
    } @else if (!hasDocuments) {
        <div class="doc-center-empty">
            <hugeicons-icon [icon]="fileIcon" [size]="32" color="var(--text-tertiary)"></hugeicons-icon>
            <span>No documents uploaded yet</span>
        </div>
    } @else {
        <div class="doc-groups">
            @for (group of groups; track group.title) {
                @if (group.docs.length) {
                    <div class="doc-group">
                        <div class="doc-group-header">
                            <span class="doc-group-title">{{ group.title }}</span>
                            <span class="doc-group-count">{{ group.docs.length }}</span>
                        </div>
                        <div class="doc-group-list">
                            @for (doc of group.docs; track doc.path) {
                                <div class="doc-item" [class.clickable]="doc.path" (click)="doc.path && viewDocument(doc.path)">
                                    <div class="doc-item-ext" [class.pdf]="getFileExt(doc.name) === 'PDF'"
                                        [class.img]="getFileExt(doc.name) === 'PNG' || getFileExt(doc.name) === 'JPG' || getFileExt(doc.name) === 'JPEG'">
                                        {{ getFileExt(doc.name) }}
                                    </div>
                                    <div class="doc-item-info">
                                        <span class="doc-item-label">{{ doc.name }}</span>
                                    </div>
                                    @if (doc.path) {
                                        <button class="doc-item-view" (click)="$event.stopPropagation(); viewDocument(doc.path)">
                                            <hugeicons-icon [icon]="eyeIcon" [size]="14" color="currentColor"></hugeicons-icon>
                                        </button>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                }
            }
        </div>
    }
</div>

<!-- Upload Document Modal -->
<app-modal [isOpen]="showUploadModal" [title]="'Add Document'" [size]="'sm'" [showCloseButton]="true"
    [submitButtonText]="uploading ? 'Uploading...' : 'Upload'"
    [submitButtonDisabled]="!uploadFile || uploading"
    (close)="showUploadModal = false"
    (cancel)="showUploadModal = false"
    (submit)="submitUpload()">
    <div class="form-group mb-12">
        <label>Document Label Name</label>
        <input type="text" [(ngModel)]="uploadDocType" placeholder="Enter document label name (optional)">
    </div>
    <div class="form-group">
        <label>File</label>
        <div class="add-doc-upload-area" (click)="fileInput.click()">
            @if (!uploadFile) {
                <hugeicons-icon [icon]="uploadIcon" [size]="28" color="var(--text-tertiary)"></hugeicons-icon>
                <span class="add-doc-upload-text">Click to select a file</span>
                <span class="add-doc-upload-hint">PDF, DOC, JPG, PNG (up to 25MB)</span>
            } @else {
                <div class="add-doc-selected-file">
                    <hugeicons-icon [icon]="fileIcon" [size]="18" color="var(--primary-500)"></hugeicons-icon>
                    <span class="add-doc-file-name">{{ uploadFile.name }}</span>
                    <button class="add-doc-remove-btn" (click)="$event.stopPropagation(); removeFile()">
                        &times;
                    </button>
                </div>
            }
        </div>
        <input #fileInput type="file" accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xlsx,.xls,.txt" style="display:none"
            (change)="onFileSelected($event)">
    </div>
</app-modal>
